import { Badge } from '@/components/ui/badge';
import type { ReactNode } from 'react';
import { formatElapsed } from './utils';

interface TalkSessionHeaderProps {
  title: string;
  subtitle: string;
  createdAt: string | Date;
  actionSlot?: ReactNode;
}

export function TalkSessionHeader({
  title,
  subtitle,
  createdAt,
  actionSlot,
}: TalkSessionHeaderProps) {
  return (
    <section className="border-b bg-background/95 px-4 pb-3 pt-[calc(env(safe-area-inset-top)+10px)] backdrop-blur supports-[backdrop-filter]:bg-background/80 sm:px-6 lg:px-8 md:pt-3">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs font-medium uppercase tracking-[0.18em] text-primary">Talk</p>
          <h1 className="mt-1 truncate text-2xl font-semibold tracking-tight">{title}</h1>
          <div className="mt-2 flex flex-wrap items-center gap-2 text-sm text-muted-foreground">
            <Badge variant="secondary">Started {formatElapsed(createdAt)}</Badge>
            {subtitle ? <span className="truncate">{subtitle}</span> : null}
          </div>
        </div>
        {actionSlot ? <div className="flex items-center gap-2">{actionSlot}</div> : null}
      </div>
    </section>
  );
}
